/* eslint-disable */

const INITIAL_STATE = {
  error: { message : '', isVisible: false },
  success: { message : '', isVisible: false },
  info: { message : '', isVisible: false },
};

const snackBarReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'CLOSE_ERROR':
      return { ...state, error: { message : '', isVisible: false } }

    case 'OPEN_ERROR':
      return { ...state, error: { message : action.payload, isVisible: true } }

    case 'CLOSE_SUCCESS':
      return { ...state, success: { message : '', isVisible: false } }

    case 'OPEN_SUCCESS':
      return { ...state, success: { message : action.payload, isVisible: true } }

    case 'CLOSE_INFO':
      return { ...state, info: { message : '', isVisible: false } }

    case 'OPEN_INFO':
      return { ...state, info: { message : action.payload, isVisible: true } }

    case 'LOGOUT_SUCCESS':
      return INITIAL_STATE

    default:
      return state
  }
}

export default snackBarReducer



// WEBPACK FOOTER //
// ./src/reducers/snackBarReducer.js